module.exports = __webpack_public_path__ + "img/signup_logo.2fecbc3b.svg";